/** @deprecated */
export { MdProgressSpinner as MdProgressCircle } from './progress-spinner';
/** @deprecated */
export { MdProgressSpinnerModule as MdProgressCircleModule } from './progress-spinner';
//# sourceMappingURL=progress-circle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/progress-spinner/progress-circle.js
// module id = 1031
// module chunks = 3